export const DEFAULT_START_STEP = {
  id: 'start',
  heading: 'Instruction',
  type: 'html',
  text: '',
  actions: [],
};

export function createWorkflowStep(nodeType, id) {
  if (nodeType === 'form') {
    return {
      id,
      type: 'form',
      heading: 'Form',
      slug: '',
      actions: [],
    };
  }

  if (nodeType === 'photo') {
    return {
      id,
      type: 'photo',
      heading: 'Photo',
      label: 'Photo capture',
      text: '',
      graphic: '',
      required: true,
      actions: [],
    };
  }

  return {
    id,
    type: 'html',
    heading: 'Instruction',
    text: '',
    actions: [],
  };
}
